<!-- <p>Search by vehicle modal body</p> -->
<!-- Modal Search by Vehicle Modal -->
<div class="modal-dialog" role="document">
	<div class="modal-content">
	  <div class="modal-header border-0">
	    <h5 class="modal-title" id="exampleModalLabel">Search by Vehicle</h5>
	    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
	      <span aria-hidden="true">&times;</span>
	    </button>
	  </div>
	  <div class="modal-body border-0">
	    <form [formGroup]="form" (ngSubmit)="onSubmit()">

	      <div class="grid-row-box grid-row-box2">
	        <div class="form-group">
	          <select class="form-control search-inputs" id="sel1" formControlName="make" (change)="onMakeSelect()">
	            <option value="">{{ loadMake ? '...Loading' : '1 &nbsp;|&nbsp; Make' }}</option>
	            <option *ngFor="let make of makes" [value]="make.slug">{{ make.name }}</option>
	          </select>
	          <i class="fa fa-sort-desc"></i>
	          <div *ngIf="form.get('make').touched || form.get('make').dirty">
	            <span class="error" *ngIf="form.get('make').hasError('required')">This field is required</span>
	          </div>
	        </div>

	        <div class="form-group">
	          <select class="form-control search-inputs" id="sel2" formControlName="model" (change)="onModelSelect()">
	            <option value="">{{ loadModels ? '...Loading' : '2 &nbsp;|&nbsp; Model' }}</option>
	            <option *ngFor="let model of models" [value]="model.slug">{{ model.name }}</option>
	          </select>
	          <i class="fa fa-sort-desc"></i>
	          <div *ngIf="form.get('model').touched || form.get('model').dirty">
	            <span class="error" *ngIf="form.get('model').hasError('required')">This field is required</span>
	          </div>
	        </div>

	        <div class="form-group">
	          <select class="form-control search-inputs" id="sel3" formControlName="year" (change)="onYearSelect()">
	            <option value="">{{ loadYear ? '...Loading' : '3 &nbsp;|&nbsp; Year' }}</option>
	            <option *ngFor="let year of years" [value]="year.slug">{{ year.name }}</option>
	          </select>
	          <i class="fa fa-sort-desc"></i>
	          <div *ngIf="form.get('year').touched || form.get('year').dirty">
	            <span class="error" *ngIf="form.get('year').hasError('required')">This field is required</span>
	          </div>
	        </div>

	        <div class="form-group">
	          <select class="form-control search-inputs" id="sel4" formControlName="modification"
	            (change)="getSubModelText()" [disabled]="loadVehicle">
	            <option value="">
	              {{ loadModi? '...Loading': '4 &nbsp;|&nbsp; Sub Model' }}</option>
	            <option *ngFor="let mod of modifications" [value]="mod.slug">{{ mod.name }}</option>
	          </select>
	          <i class="fa fa-sort-desc"></i>
	          <div *ngIf="form.get('modification').touched || form.get('modification').dirty">
	            <span class="error" *ngIf="form.get('modification').hasError('required')">This field is required</span>
	          </div>
	        </div>


	        <div class="form-group">
	          <button type="submit" class="btn btn-02 f-large addcart new-btn bg-black w-auto go-btn-pad" [disabled]="isLoading">
	            <app-preloader *ngIf="isLoading"></app-preloader>
	            <span *ngIf="!isLoading">Go</span>
	          </button>
	        </div>
	      </div>
	    </form>

		
			<p class="mt-3">Please Note: Search by vehicle results are being optimized. Always verify offsets and brake clearance. For staggered fitments use the search by size function.</p>
		
	  </div>
	</div>
</div>
